/* src/app/modules/shared/components/column/column-cannabinoid/column-cannabinoid.component.scss */
app-column-cannabinoid {
  display: contents;
}
/*# sourceMappingURL=column-cannabinoid.component.css.map */
